import Swiper from "swiper";
import { Navigation } from "swiper/modules";

(function () {
  let numbersSwiper = [];
  let breakpoint = 1200; // Set the breakpoint for when to initialize Swiper
  const swiperSliders = document.querySelectorAll(".com-numbers-slider__slider");


  function initSwiper() {
  
    for (let i = 0; i < swiperSliders.length; i++) {
      numbersSwiper[i] = new Swiper(swiperSliders[i], {
        modules: [Navigation],
        loop: true,
        slidesPerView: 5,
        spaceBetween: 15,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 2,
        },
      });
    }
  }

  function checkBreakpoint() {
    for (let i = 0; i < swiperSliders.length; i++) {
      if (window.innerWidth >= breakpoint && !numbersSwiper[i]) {
        initSwiper();
      } else if (window.innerWidth < breakpoint && numbersSwiper[i]) {
        numbersSwiper[i].destroy(true, true);
        numbersSwiper[i] = null;
      }
    }
  }

  window.addEventListener("resize", checkBreakpoint);
  checkBreakpoint();
})();
